"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.runSanitizer = undefined;

var _ramda = require("ramda");

var _sanitizeHtml = require("sanitize-html");

var _sanitizeHtml2 = _interopRequireDefault(_sanitizeHtml);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SanitizeUtility = {
  runSanitizer: function runSanitizer(inputHtmlData) {
    if ((0, _ramda.isNil)(inputHtmlData)) {
      return "";
    } else if (typeof inputHtmlData !== "string") {
      return inputHtmlData;
    }

    return (0, _sanitizeHtml2.default)(inputHtmlData, {
      allowedTags: _sanitizeHtml2.default.defaults.allowedTags.concat(['h2', 'span', 'ul', 'li', 'u', 'sup', 'img', 'iframe', 'p']),
      allowedAttributes: {
        span: ['class', 'id', 'style'],
        ul: ['class', 'id', 'style'],
        li: ['class', 'id', 'style'],
        a: ['class', 'href', 'id', 'style', 'target', 'onclick', 'aria-label'],
        div: ['class', 'id', 'style'],
        img: ['class', 'src', 'id', 'style', 'alt'],
        iframe: ['id', 'allowfullscreen', 'class', 'frameborder', 'name', 'scrolling', 'src', 'style', 'width', 'data-name', 'height', 'title']
      }
    });
  }
};

exports.default = SanitizeUtility;
var runSanitizer = SanitizeUtility.runSanitizer;
exports.runSanitizer = runSanitizer;